




































import { Site } from "@/shared/Site";
import $store from "@/store/store";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import SelectedSites from "@/ui-component/selectedSites.vue";

@Component({
  components: { SelectedSites },
})
export default class CaisseChooser extends mixins(MobileMixin) {
  public searchTxt: string = "";
  @Prop({ default: "site" }) public site!: Site;
  @Prop() public listeCaisses!: string[];

  /*
   * methode de filtre depuis le champs de texte des sites repondant au critere de texte
   */
  public searchCaisseFilter() {
    if (this.searchTxt.trim() !== "") {
      this.mesCaisses = this.mesCaisses.filter((caisse: string) => {
        return caisse.includes(this.searchTxt);
      });
    }
    return this.mesCaisses;
  }
  /*
   * methode de verification qu'un site ets selectionné
   * @param {Site} site- le site à verifier
   */
  public isSelected(caisse: string) {
    const id = this.listeCaisses.indexOf(caisse);
    return id !== -1;
  }
  /*
   * methode de selection d'un site
   * @param {Site} site- le site à selectionner
   */
  public addCaisse(caisse: string) {
    // console.log(caisse);
    const index = this.listeCaisses.indexOf(caisse);
    const arr = this.listeCaisses;
    if (index !== -1) {
      arr.splice(index, 1);
    } else {
      arr.push(caisse);
    }
    // this.$set(this.listeCaisses, "lSites", arr);
    // console.log(this.listeCaisses);
    this.listeCaisses = arr;
    this.update();
  }

  /*
   * methode de selection ou deselection d'un site depuis la fenetre de dialogue
   * @param {Site} site- le site à selectionner
   */
  public delCaisse(caisse: string) {
    const index = this.listeCaisses.indexOf(caisse);
    if (index !== -1) {
      this.listeCaisses.splice(index, 1);
    }
  }
  /*
   * methode de mise a jour de la liste des site depuis le composant vers la page qui l'affiche
   */
  public update() {
    this.$emit("update", this.listeCaisses);
  }

  public mounted() {
    // console.log(this.listeCaisses);
  }

  get mesCaisses(): string[] {
    const caisses: string[] = this.site.caisses;
    caisses.sort((u1: string, u2: string) => {
      if (u1 > u2) {
        return 1;
      }
      if (u1 < u2) {
        return -1;
      }
      return 0;
    });
    return caisses;
  }

  set mesCaisses(caisses: string[]) {
    this.mesCaisses = caisses;
  }
}
